import React from "react";
import { HiveIcons } from "assets/icons";
import SubmenuItems from "../../components/Header/SubmenuItems";
import SearchBox from "../../components/Common/SearchBox";

const Menu = (props) => {
  const menuItems = [
    {
      pushRight: true,
      customEl: (
        <SearchBox value={props.query} onChange={props.handleChangeQuery} />
      ),
    },
    {
      divider: true,
    },
    {
      title: "New Client",
      icon: <HiveIcons.AddOutlined />,
      onClick: props.handleCreateNew,
    },
  ];

  return <SubmenuItems items={menuItems} />;
};

export default Menu;
